import axios from 'axios';
import fecha from 'fecha';
import { SERVER_URL } from '../../../../constants/ClientConfig';
import {
  CHANGE_USER_DATA,
  CREATE_ACCOUNT,
  FILL_DATA_FROM_PINCODE,
  FILL_MOBILE,
  FILL_USER_DATA,
  FILL_USERNAME,
  TOGGLE_CHOICE,
  ACTION_SET_SESSION_ID_AND_CAPTCHA,
} from '../../../../constants/ActionTypes';
import { trackClickEventProp61 } from "../../../../../src/utils/omnitureTracker";
import { checkValidation, validations } from "../../../../constants/Validators";
import {
  COUNTRY_PREFERENCE_DEFAULT,
  IRCTC_ACCOUNT_REGISTER_COUNT
} from "../../../../constants/TrainConstants";
import { generateId } from '../../../../utils/trainUtils';

export const captchaAndSessionId = () => async (dispatch, getState) => {
  const traceId= generateId();
  try {
    const headers = {"X-Trace-Id": traceId};
    dispatch({
      type: ACTION_SET_SESSION_ID_AND_CAPTCHA,
      payload: { captchaLoading: true }
    });
    const res = await axios.get(`${SERVER_URL}/getCaptcha`,{ headers });
    const { captchaQuestion = null, status = null } = res?.data?.data ?? {};
    const { success, error = null } = res.data;
    if (res.status === 200 && success) {
      dispatch({
        type: ACTION_SET_SESSION_ID_AND_CAPTCHA,
        payload: {
          captchaQuestion,
          status,
          captchaLoading: false,
          irctcDowntimeError: error
        }
      });
    } else {
      trackClickEventProp61(
        "irctc_create_account",
        "rails_create_irctc_account_captcha_failed"
      );
      dispatch({
        type: ACTION_SET_SESSION_ID_AND_CAPTCHA,
        payload: {
          captchaQuestion: null,
          status: null,
          captchaLoading: false,
          irctcDowntimeError: null
        }
      });
    }
  } catch (e) {
    trackClickEventProp61(
      "irctc_create_account",
      "rails_create_irctc_account_captcha_failed"
    );
    dispatch({
      type: ACTION_SET_SESSION_ID_AND_CAPTCHA,
      payload: {
        captchaQuestion: null,
        status: null,
        captchaLoading: false,
        irctcDowntimeError: null
      }
    });
    console.log("error is ", e);
  }

}
export const fillCreateAccountData =  () => async (dispatch, getState) =>  {
  const traceId= generateId();
  try {
    const headers = {"X-Trace-Id": traceId};
    const res = await axios.get(`${SERVER_URL}/getOptions`,{ headers });
    const { securityQuestionList, occupationList } = res.data;
    const [ securityQuestion ] = securityQuestionList;
    const [ occupation ] = occupationList;
    dispatch({
      type: FILL_USER_DATA,
      payload: { securityQuestionList, occupationList,
        securityQuestion, occupation, country: COUNTRY_PREFERENCE_DEFAULT,
        officeCountry: COUNTRY_PREFERENCE_DEFAULT },
    });
  } catch (error) {
    console.error(error);
  }
};

export const changeUserData = (key, value) => (dispatch) => {
  dispatch({
    type: CHANGE_USER_DATA,
    payload: { [key]: value },
  });
};

export const changeUserName = (userName) => async (dispatch) => {
  const traceId = generateId();
  try {
    const headers = {"X-Trace-Id": traceId};
    if (checkValidation(userName, validations.userName)) {
      const body = { userid: userName };
      const res = await axios.post(`${SERVER_URL}/userAvailability`, body,{ headers });
      if (res.data.useridAvailable === 'FALSE') {
        dispatch({
          type: FILL_USERNAME,
          payload: { userName, userNameErrorMessage: 'User name is already registered' },
        });
      } else if (res.data.useridAvailable === 'TRUE') {
        dispatch({
          type: FILL_USERNAME,
          payload: { userName, userNameErrorMessage: '' },
        });
      } else if (res.data.errorMessage) {
        dispatch({
          type: FILL_MOBILE,
          payload: { userName, userNameErrorMessage: res.data.errorMessage },
        });
      }
    } else {
      dispatch({
        type: FILL_USERNAME,
        payload: { userName, userNameErrorMessage: '' },
      });
    }
  } catch (error) {
    console.error(error);
  }
};

export const changeEmail = (email) => async (dispatch) => {
  const traceId = generateId();
  try {
    const headers = {"X-Trace-Id": traceId};
    if (checkValidation(email, validations.email)) {
      const body = { email };
      const res = await axios.post(`${SERVER_URL}/userAvailability`, body,{ headers });
      if (res.data.emailAvailable === 'FALSE') {
        dispatch({
          type: FILL_USERNAME,
          payload: { email, emailErrorMessage: 'Email is already registered' },
        });
      } else if (res.data.emailAvailable === 'TRUE') {
        dispatch({
          type: FILL_USERNAME,
          payload: { email, emailErrorMessage: '' },
        });
      } else if (res.data.errorMessage) {
        dispatch({
          type: FILL_MOBILE,
          payload: { email, emailErrorMessage: res.data.errorMessage },
        });
      }
    } else {
      dispatch({
        type: FILL_USERNAME,
        payload: { email, emailErrorMessage: '' },
      });
    }
  } catch (error) {
    console.error(error);
  }
};

export const changeMobile = (mobileNumber) => async (dispatch) => {
  const traceId = generateId();
  try {
    const headers = {"X-Trace-Id": traceId};
    if (checkValidation(mobileNumber, validations.mobileNumber)) {
      const body = { mobile: mobileNumber };
      const res = await axios.post(`${SERVER_URL}/userAvailability`, body,{ headers });
      if (res.data.mobileAvailable === 'FALSE') {
        dispatch({
          type: FILL_MOBILE,
          payload: { mobileNumber, mobileErrorMessage: 'Mobile number is already registered' },
        });
      } else if (res.data.mobileAvailable === 'TRUE') {
        dispatch({
          type: FILL_MOBILE,
          payload: { mobileNumber, mobileErrorMessage: '' },
        });
      } else if (res.data.errorMessage) {
        dispatch({
          type: FILL_MOBILE,
          payload: { mobileNumber, mobileErrorMessage: res.data.errorMessage },
        });
      }
    } else {
      dispatch({
        type: FILL_MOBILE,
        payload: { mobileNumber, mobileErrorMessage: '' },
      });
    }
  } catch (error) {
    console.error(error);
  }
};

export const getDetailsFromPinCode = (pinCode) => async (dispatch) => {
  const traceId = generateId();
  try {
    const headers = {"X-Trace-Id": traceId};
    if (checkValidation(pinCode, validations.pinCode)) {
      const body = { pinCode };
      const res = await axios.post(`${SERVER_URL}/pinCode`, body,{ headers });
      if (res.data.errorDetails) {
        dispatch({
          type: FILL_DATA_FROM_PINCODE,
          payload: { pinCode, pinCodeErrorMessage: res.data.errorDetails.errorMessage },
        });
      } else {
        const cityList = [ { id: 0, text: res.data.city } ];
        const postOfficeList = res.data.postOfficeList.map((item, index) => ({ id: index, text: item }));
        const stateList = [ { id: 0, text: res.data.state } ];
        const [ city ] = cityList;
        const [ postOffice ] = postOfficeList;
        const [ regionalState ] = stateList;
        dispatch({
          type: FILL_DATA_FROM_PINCODE,
          payload: { cityList, postOfficeList, stateList, city, postOffice, regionalState,
            pinCode, pinCodeErrorMessage: '' },
        });
      }
    } else {
      dispatch({
        type: FILL_DATA_FROM_PINCODE,
        payload: { pinCode, pinCodeErrorMessage: '' },
      });
    }
  } catch (error) {
    console.error(error);
  }
};

export const getDetailsFromOfficePinCode = (officePinCode) => async (dispatch) => {
  const traceId = generateId();
  try {
    const headers = {"X-Trace-Id": traceId};
    if (checkValidation(officePinCode, validations.officePinCode)) {
      const body = { pinCode: officePinCode };
      const res = await axios.post(`${SERVER_URL}/pinCode`, body,{ headers });
      if (res.data.errorDetails) {
        dispatch({
          type: FILL_DATA_FROM_PINCODE,
          payload: { officePinCode, officePinCodeErrorMessage: res.data.errorDetails.errorMessage },
        });
      } else {
        const officeCityList = [ { id: 0, text: res.data.city } ];
        const officePostOfficeList = res.data.postOfficeList.map((item, index) => ({ id: index, text: item }));
        const officeStateList = [ { id: 0, text: res.data.state } ];
        const [ officeCity ] = officeCityList;
        const [ officePostOffice ] = officePostOfficeList;
        const [ officeRegionalState ] = officeStateList;
        dispatch({
          type: FILL_DATA_FROM_PINCODE,
          payload: { officeCityList, officePostOfficeList, officeStateList, officeCity,
            officePostOffice, officeRegionalState,
            officePinCode, officePinCodeErrorMessage: '' },
        });
      }
    } else {
      dispatch({
        type: FILL_DATA_FROM_PINCODE,
        payload: { officePinCode, officePinCodeErrorMessage: '' },
      });
    }
  } catch (error) {
    console.error(error);
  }
};

export const toggleChoice = (key) => (dispatch, getState) => {
  const { newAccount } = getState();
  const newPref = !newAccount[key];
  dispatch({
    type: TOGGLE_CHOICE,
    payload: { [key]: newPref },
  });
};

export const createAccount = (data) => async (dispatch,getState) => {
  const traceId = generateId();
  let accountRegisterApiCount =  JSON.parse(localStorage.getItem(IRCTC_ACCOUNT_REGISTER_COUNT));
  if (!accountRegisterApiCount) {
    accountRegisterApiCount = 0;
  }

  try {
    const { newAccount } = getState();
    const { status } = newAccount;
    const {
      userName,
      password,
      securityQuestion,
      securityAnswer,
      language,
      firstName,
      lastName,
      email,
      mobileNumber,
      dateOfBirth,
      occupation,
      maritalStatus,
      country,
      gender,
      residentialAddress,
      regionalState,
      pinCode,
      city,
      postOffice,
      residentialMobileNumber,
      officeCheckBoxEnabled,
      enterCaptcha
    } = data;
    const body = {
      userName,
      passWord: password,
      cnfPassWord: password,
      securityQuestion: securityQuestion.id,
      securityAns: securityAnswer,
      prefLanguage: language.id,
      firstName,
      lastName,
      email,
      mobile: mobileNumber,
      dob: fecha.format(dateOfBirth, "YYYYMMDD"),
      occupation: occupation.id,
      martialStatus: maritalStatus.id,
      nationalityId: country.obj.key,
      gender: gender.obj.value,
      address: residentialAddress,
      countryId: country.obj.key,
      otherCountry: country.text,
      otherState: regionalState.text,
      otherCity: city.text,
      pinCode,
      state: regionalState.text,
      city: city.text,
      area: city.text,
      greq: status,
      captcha: enterCaptcha,
      postOffice: postOffice.text,
      landlineNumber: residentialMobileNumber,
      ...(officeCheckBoxEnabled
        ? {
            copyAddressResToOff: "N",
            off_Address: data.officeAddress,
            off_CountryId: data.officeCountry.obj.key,
            off_otherCountry: data.officeCountry.obj.key,
            off_otherState: data.officeRegionalState.text,
            off_otherCity: data.officeCity.text,
            off_PinCode: data.officePinCode,
            off_State: data.officeRegionalState.text,
            off_City: data.officeCity.text,
            off_PostOffice: data.officePostOffice.text,
            off_LandlineNumber: data.officeMobileNumber
          }
        : {
            copyAddressResToOff: "Y",
            off_Address: residentialAddress,
            off_CountryId: country.obj.key,
            off_otherCountry: country.obj.key,
            off_otherState: regionalState.text,
            off_otherCity: city.text,
            off_PinCode: pinCode,
            off_State: regionalState.text,
            off_City: city.text,
            off_PostOffice: postOffice.text,
            off_LandlineNumber: residentialMobileNumber
          })
    };
    const headers = {"X-Trace-Id": traceId};
    const res = await axios.post(`${SERVER_URL}/registerUser`, body,{headers});
    const { regFlag, error } = res.data;
    const errorId = res.headers["X-Trace-Id"];

    if (regFlag === true) {
      trackClickEventProp61(
        "irctc_create_account",
        "rails_create_irctc_account_enter_valid_details_red_flag"
      );
    }
    if (error === "Invalid Captcha.") {
      if (accountRegisterApiCount === 9) {
        captchaAndSessionId();
      } else {
        const { captchaQuestion, status } = res?.data?.captchaDTO;
        dispatch({
          type: ACTION_SET_SESSION_ID_AND_CAPTCHA,
          payload: {
            captchaQuestion,
            status,
            captchaLoading: false,
            irctcDowntimeError: null
          }
        });
      }
    }

    localStorage.setItem(
      IRCTC_ACCOUNT_REGISTER_COUNT,
      JSON.stringify((accountRegisterApiCount + 1) % 10)
    );

    if (error) {
      trackClickEventProp61(
        "irctc_create_account",
        "rails_create_irctc_account_enter_valid_details"
      );
      dispatch({
        type: CREATE_ACCOUNT,
        payload: {
          createAccountError: !!error,
          createAccountErrorMessage: error,       
          errorId :"Error Code: " + (res?.data?.errorDetails?.errorCode ?? "Rails_No_BE") + "."+traceId
        }
      });
    } else {
      dispatch({
        type: CREATE_ACCOUNT,
        payload: { regFlag: !regFlag }
      });
    }
  } catch (e) {
    trackClickEventProp61(
      "irctc_create_account",
      "rails_create_irctc_account_something_went_wrong"
    );
    localStorage.setItem(
      IRCTC_ACCOUNT_REGISTER_COUNT,
      JSON.stringify((accountRegisterApiCount + 1) % 10)
    );
  }

};
